.main-row
    .container
        .row

#build-preview-frame
